import { render } from "./SimpleOverlay.vue?vue&type=template&id=4d441e4b&ts=true"
import script from "./SimpleOverlay.vue?vue&type=script&lang=ts"
export * from "./SimpleOverlay.vue?vue&type=script&lang=ts"

import "./SimpleOverlay.vue?vue&type=style&index=0&id=4d441e4b&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__